<template>
  <el-dialog title="更改手机号" :visible.sync="modalShow">
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="100px">
      <el-form-item label="新手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="新手机号" clearable maxlength="11"/>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="modalShow = false">取消</el-button>
      <el-button type="primary" size="small" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateUserPhone } from "@/api/product/base"
const rules = {
  phone: [
    { required: true, message: "请输入手机号", trigger: "blur" },
  ],
}
export default {
  data () {
    return {
      modalShow: false,
      rules,
      form: {
        phone: null
      }
    }
  },
  methods: {
    init (item) {
      const defaultData = this.$options.data()
      if (!item) {
        this.form = defaultData.form
        this.id = null
      } else {
        Object.keys(this.form).forEach(keys => {
          if (item[keys]) {
            this.form[keys] = item[keys]
          }
        })
        this.id = item.id
      }
      this.modalShow = true
    },
    async submit () {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        const params = {
          id: this.id,
          phone: this.form.phone
        }
        const res = await updateUserPhone(params)
        this.modalShow = false
        this.$message.success('操作成功！')
        this.$emit('update', true)
      })
    }
  }
}
</script>

<style>
</style>